// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f0f2f5;
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/Loading/PageLoader.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACJ","sourcesContent":[".page-loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background: #f0f2f5;\n}\n@primary-color: #1890ff;@border-radius-base: 8px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
